import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * ProtectedRoute - A gatekeeper component for restricted routes.
 * Redirects to home if the user doesn't have the required role.
 */
const ProtectedRoute = ({ children, roleRequired = 'admin' }) => {
    const { user, loading } = useAuth();

    // Show nothing while checking authentication status
    if (loading) {
        return <div className="loading-screen">Authenticating...</div>;
    }

    // Redirect to home if not logged in
    if (!user) {
        return <Navigate to="/" replace />;
    }

    // Redirect to home if role doesn't match
    if (user.role !== roleRequired) {
        console.warn(`Access Denied: Required role '${roleRequired}', found '${user.role}'`);
        return <Navigate to="/" replace />;
    }

    return children;
};

export default ProtectedRoute;

